import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=1494ecf4&"
import script from "./GeneralInfo.vue?vue&type=script&lang=ts&"
export * from "./GeneralInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports